// extracted by mini-css-extract-plugin
export var dropdown = "_um-0";
export var imageWrapper = "_um-3";
export var itemNameContainer = "_um-1";
export var productImage = "_um-2";
export var spinnerWrapper = "_um-4";